import { Component, OnInit } from '@angular/core';
import { BillingInvoiceManualEditService } from 'src/app/services/billing/billing-invoice-manual/billing-invoice-manual-edit.service';
import { BillingInvoiceEditService } from 'src/app/services/billing/billing-invoice/billing-invoice-edit.service';
import { MenuService } from 'src/app/services/menu.service';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { InvoiceType } from '../../../enums/invoice-type.enum';

@Component({
  selector: 'app-billing-invoice-manual-edit',
  templateUrl: './billing-invoice-manual-edit.component.html',
  styleUrls: ['./billing-invoice-manual-edit.component.css'],
  providers: [{ provide: BillingInvoiceEditService, useClass: BillingInvoiceManualEditService }]
})

export class BillingInvoiceManualEditComponent implements OnInit {

  loading: boolean;
  typeId: number;
  enabledClientSearch = true;

  constructor  ( private menuService: MenuService,
                  private billingInvoiceEditService: BillingInvoiceEditService,
                  private authService: AuthService,
                  private route: ActivatedRoute ) {

    this.menuService.setMenuTitle('Factura', 'Manual');
   }

  ngOnInit() {

    this.loading = true;
    this.typeId = +this.route.snapshot.paramMap.get('Type');
    this.billingInvoiceEditService.setBillingInvoiceManualParams(
        this.authService.getSectorId(), this.typeId );
    this.loading = false;
  }

}
